window.CountryListCode =
[
    {
        "CountryName":"Afghanistan",
        "FlagIcon":"/Assets/images/CountryCode/AfghanistanNew.jpg",
        "CountryCode":"93"
    },
    {
        "CountryName":"Åland Islands",
        "FlagIcon":"/Assets/images/CountryCode/AlandIslands.svg",
        "CountryCode":"358-18"
    },
    {
        "CountryName":"Albania",
        "FlagIcon":"/Assets/images/CountryCode/Albania.svg",
        "CountryCode":"355"
    },
    {
        "CountryName":"Algeria",
        "FlagIcon":"/Assets/images/CountryCode/Algeria.svg",
        "CountryCode":"213"
    },
    {
        "CountryName":"American Samoa",
        "FlagIcon":"/Assets/images/CountryCode/AmericanSamoa.svg",
        "CountryCode":"1-684"
    },
    {
        "CountryName":"Andorra",
        "FlagIcon":"/Assets/images/CountryCode/Andorra.svg",
        "CountryCode":"376"
    },
    {
        "CountryName":"Angola",
        "FlagIcon":"/Assets/images/CountryCode/Angola.svg",
        "CountryCode":"244"
    },
    {
        "CountryName":"Anguilla",
        "FlagIcon":"/Assets/images/CountryCode/Anguilla.svg",
        "CountryCode":"1-264"
    },
    {
        "CountryName":"Antigua and Barbuda",
        "FlagIcon":"/Assets/images/CountryCode/AntiguaAndBarbuda.svg",
        "CountryCode":"1-268"
    },
    {
        "CountryName":"Argentina",
        "FlagIcon":"/Assets/images/CountryCode/Argentina.svg",
        "CountryCode":"54"
    },
    {
        "CountryName":"Armenia",
        "FlagIcon":"/Assets/images/CountryCode/Armenia.svg",
        "CountryCode":"374"
    },
    {
        "CountryName":"Aruba",
        "FlagIcon":"/Assets/images/CountryCode/Aruba.svg",
        "CountryCode":"297"
    },
    {
        "CountryName":"Ascension Islands",
        "FlagIcon":"/Assets/images/CountryCode/AscensionIslands.svg",
        "CountryCode":"247"
    },
    {
        "CountryName":"Australia",
        "FlagIcon":"/Assets/images/CountryCode/Australia.svg",
        "CountryCode":"61"
    },
    {
        "CountryName":"Austria",
        "FlagIcon":"/Assets/images/CountryCode/Austria.svg",
        "CountryCode":"43"
    },
    {
        "CountryName":"Azerbaijan",
        "FlagIcon":"/Assets/images/CountryCode/Azerbaijan.svg",
        "CountryCode":"994"
    },
    {
        "CountryName":"Bahamas",
        "FlagIcon":"/Assets/images/CountryCode/Bahamas.svg",
        "CountryCode":"1-242"
    },
    {
        "CountryName":"Bahrain",
        "FlagIcon":"/Assets/images/CountryCode/Bahrain.svg",
        "CountryCode":"973"
    },
    {
        "CountryName":"Bangladesh",
        "FlagIcon":"/Assets/images/CountryCode/Bangladesh.svg",
        "CountryCode":"880"
    },
    {
        "CountryName":"Barbados",
        "FlagIcon":"/Assets/images/CountryCode/Barbados.svg",
        "CountryCode":"1-246"
    },
    {
        "CountryName":"Basque Country",
        "FlagIcon":"/Assets/images/CountryCode/BasqueCountry.svg",
        "CountryCode":"34-94"
    },
    {
        "CountryName":"Belarus",
        "FlagIcon":"/Assets/images/CountryCode/Belarus.svg",
        "CountryCode":"375"
    },
    {
        "CountryName":"Belgium",
        "FlagIcon":"/Assets/images/CountryCode/Belgium.svg",
        "CountryCode":"32"
    },
    {
        "CountryName":"Belize",
        "FlagIcon":"/Assets/images/CountryCode/Belize.svg",
        "CountryCode":"501"
    },
    {
        "CountryName":"Benin",
        "FlagIcon":"/Assets/images/CountryCode/Benin.svg",
        "CountryCode":"229"
    },
    {
        "CountryName":"Bermuda",
        "FlagIcon":"/Assets/images/CountryCode/Bermuda.svg",
        "CountryCode":"1-441"
    },
    {
        "CountryName":"Bhutan",
        "FlagIcon":"/Assets/images/CountryCode/Bhutan.svg",
        "CountryCode":"975"
    },
    {
        "CountryName":"Bolivia",
        "FlagIcon":"/Assets/images/CountryCode/Bolivia.svg",
        "CountryCode":"591"
    },
    {
        "CountryName":"Bonaire",
        "FlagIcon":"/Assets/images/CountryCode/BonaireNew.svg",
        "CountryCode":"599-7"
    },
    {
        "CountryName":"Bosnia and Herzegovina",
        "FlagIcon":"/Assets/images/CountryCode/BosniaAndHerzegovina.svg",
        "CountryCode":"387"
    },
    {
        "CountryName":"Botswana",
        "FlagIcon":"/Assets/images/CountryCode/Botswana.svg",
        "CountryCode":"267"
    },
    {
        "CountryName":"Bouvet Island",
        "FlagIcon":"/Assets/images/CountryCode/BouvetIsland.svg",
        "CountryCode":"47"
    },
    {
        "CountryName":"Brazil",
        "FlagIcon":"/Assets/images/CountryCode/Brazil.svg",
        "CountryCode":"55"
    },
    {
        "CountryName":"British Indian Ocean Territory (Diego Garcia)",
        "FlagIcon":"/Assets/images/CountryCode/BritishIndianOceanTerritory.svg",
        "CountryCode":"246"
    },
    {
        "CountryName":"British Virgin Islands",
        "FlagIcon":"/Assets/images/CountryCode/BritishVirginIslands.svg",
        "CountryCode":"1-284"
    },
    {
        "CountryName":"Brunei Darussalam",
        "FlagIcon":"/Assets/images/CountryCode/BruneiDarussalam.svg",
        "CountryCode":"673"
    },
    {
        "CountryName":"Bulgaria",
        "FlagIcon":"/Assets/images/CountryCode/Bulgaria.svg",
        "CountryCode":"359"
    },
    {
        "CountryName":"Burkina Faso",
        "FlagIcon":"/Assets/images/CountryCode/BurkinaFaso.svg",
        "CountryCode":"226"
    },
    {
        "CountryName":"Burundi",
        "FlagIcon":"/Assets/images/CountryCode/Burundi.svg",
        "CountryCode":"257"
    },
    {
        "CountryName":"Cape Verde",
        "FlagIcon":"/Assets/images/CountryCode/CapeVerde.svg",
        "CountryCode":"238"
    },
    {
        "CountryName":"Cambodia",
        "FlagIcon":"/Assets/images/CountryCode/Cambodia.svg",
        "CountryCode":"855"
    },
    {
        "CountryName":"Cameroon",
        "FlagIcon":"/Assets/images/CountryCode/Cameroon.svg",
        "CountryCode":"237"
    },
    {
        "CountryName":"Canada",
        "FlagIcon":"/Assets/images/CountryCode/Canada.svg",
        "CountryCode":"1"
    },
    {
        "CountryName":"Cayman Islands",
        "FlagIcon":"/Assets/images/CountryCode/CaymanIslands.svg",
        "CountryCode":"1-345"
    },
    {
        "CountryName":"Central African Republic",
        "FlagIcon":"/Assets/images/CountryCode/CentralAfricanRepublic.svg",
        "CountryCode":"236"
    },
    {
        "CountryName":"Chad",
        "FlagIcon":"/Assets/images/CountryCode/Chad.svg",
        "CountryCode":"235"
    },
    {
        "CountryName":"Chile",
        "FlagIcon":"/Assets/images/CountryCode/Chile.svg",
        "CountryCode":"56"
    },
    {
        "CountryName":"China",
        "FlagIcon":"/Assets/images/CountryCode/China.svg",
        "CountryCode":"86"
    },
    {
        "CountryName":"Christmas Island",
        "FlagIcon":"/Assets/images/CountryCode/ChristmasIsland.svg",
        "CountryCode":"61-89164"
    },
    {
        "CountryName":"Cocos (Keeling) Islands",
        "FlagIcon":"/Assets/images/CountryCode/Cocos(Keeling)Islands.svg",
        "CountryCode":"61-89162"
    },
    {
        "CountryName":"Colombia",
        "FlagIcon":"/Assets/images/CountryCode/Colombia.svg",
        "CountryCode":"57"
    },
    {
        "CountryName":"Comoros",
        "FlagIcon":"/Assets/images/CountryCode/Comoros.svg",
        "CountryCode":"269"
    },
    {
        "CountryName":"Republic of the Congo",
        "FlagIcon":"/Assets/images/CountryCode/Congo.svg",
        "CountryCode":"242"
    },
    {
        "CountryName":"Democratic Republic of the Congo",
        "FlagIcon":"/Assets/images/CountryCode/DemocraticRepublicoftheCongo.svg",
        "CountryCode":"243"
    },
    {
        "CountryName":"Cook Islands",
        "FlagIcon":"/Assets/images/CountryCode/CookIslands.svg",
        "CountryCode":"682"
    },
    {
        "CountryName":"Costa Rica",
        "FlagIcon":"/Assets/images/CountryCode/CostaRica.svg",
        "CountryCode":"506"
    },
    {
        "CountryName":"Ivory Coast (Côte d'Ivoire)",
        "FlagIcon":"/Assets/images/CountryCode/Côted'Ivoire.svg",
        "CountryCode":"225"
    },
    {
        "CountryName":"Croatia",
        "FlagIcon":"/Assets/images/CountryCode/Croatia.svg",
        "CountryCode":"385"
    },
    {
        "CountryName":"Cuba",
        "FlagIcon":"/Assets/images/CountryCode/Cuba.svg",
        "CountryCode":"53"
    },
    {
        "CountryName":"Curaçao",
        "FlagIcon":"/Assets/images/CountryCode/Curaçao.svg",
        "CountryCode":"599-9"
    },
    {
        "CountryName":"Cyprus",
        "FlagIcon":"/Assets/images/CountryCode/Cyprus.svg",
        "CountryCode":"357"
    },
    {
        "CountryName":"Czech Republic",
        "FlagIcon":"/Assets/images/CountryCode/CzechRepublic.svg",
        "CountryCode":"420"
    },
    {
        "CountryName":"Denmark",
        "FlagIcon":"/Assets/images/CountryCode/Denmark.svg",
        "CountryCode":"45"
    },
    {
        "CountryName":"Djibouti",
        "FlagIcon":"/Assets/images/CountryCode/Djibouti.svg",
        "CountryCode":"253"
    },
    {
        "CountryName":"Dominica",
        "FlagIcon":"/Assets/images/CountryCode/Dominica.svg",
        "CountryCode":"1-767"
    },
    {
        "CountryName":"Dominican Republic",
        "FlagIcon":"/Assets/images/CountryCode/DominicanRepublic.svg",
        "CountryCode":"1-809"
    },
    // {
    //     "CountryName":"Dominican Republic",
    //     "FlagIcon":"/Assets/images/CountryCode/DominicanRepublic.svg",
    //     "CountryCode":"1-829"
    // },
    // {
    //     "CountryName":"Dominican Republic",
    //     "FlagIcon":"/Assets/images/CountryCode/DominicanRepublic.svg",
    //     "CountryCode":"1-849"
    // },
    {
        "CountryName":"Ecuador",
        "FlagIcon":"/Assets/images/CountryCode/Ecuador.svg",
        "CountryCode":"593"
    },
    {
        "CountryName":"Egypt",
        "FlagIcon":"/Assets/images/CountryCode/Egypt.svg",
        "CountryCode":"20"
    },
    {
        "CountryName":"El Salvador",
        "FlagIcon":"/Assets/images/CountryCode/ElSalvador.svg",
        "CountryCode":"503"
    },
    {
        "CountryName":"England",
        "FlagIcon":"/Assets/images/CountryCode/England.svg",
        "CountryCode":"44"
    },
    {
        "CountryName":"Equatorial Guinea",
        "FlagIcon":"/Assets/images/CountryCode/EquatorialGuinea.svg",
        "CountryCode":"240"
    },
    {
        "CountryName":"Eritrea",
        "FlagIcon":"/Assets/images/CountryCode/Eritrea.svg",
        "CountryCode":"291"
    },
    {
        "CountryName":"Estonia",
        "FlagIcon":"/Assets/images/CountryCode/Estonia.svg",
        "CountryCode":"372"
    },
    {
        "CountryName":"Eswatini",
        "FlagIcon":"/Assets/images/CountryCode/Eswatini.svg",
        "CountryCode":"268"
    },
    {
        "CountryName":"Ethiopia",
        "FlagIcon":"/Assets/images/CountryCode/Ethiopia.svg",
        "CountryCode":"251"
    },
    {
        "CountryName":"Falkland Islands",
        "FlagIcon":"/Assets/images/CountryCode/FalklandIslands.svg",
        "CountryCode":"500"
    },
    {
        "CountryName":"Faroe Islands",
        "FlagIcon":"/Assets/images/CountryCode/FaroeIslands.svg",
        "CountryCode":"298"
    },
    {
        "CountryName":"Fiji",
        "FlagIcon":"/Assets/images/CountryCode/Fiji.svg",
        "CountryCode":"679"
    },
    {
        "CountryName":"Finland",
        "FlagIcon":"/Assets/images/CountryCode/Finland.svg",
        "CountryCode":"358"
    },
    {
        "CountryName":"France",
        "FlagIcon":"/Assets/images/CountryCode/France.svg",
        "CountryCode":"33"
    },
    {
        "CountryName":"French Guiana",
        "FlagIcon":"/Assets/images/CountryCode/FrenchGuiana.svg",
        "CountryCode":"594"
    },
    {
        "CountryName":"French Polynesia",
        "FlagIcon":"/Assets/images/CountryCode/FrenchPolynesia.svg",
        "CountryCode":"689"
    },
    {
        "CountryName":"Gabon",
        "FlagIcon":"/Assets/images/CountryCode/Gabon.svg",
        "CountryCode":"241"
    },    {
        "CountryName":"Gambia",
        "FlagIcon":"/Assets/images/CountryCode/Gambia.svg",
        "CountryCode":"220"
    },
    {
        "CountryName":"Georgia",
        "FlagIcon":"/Assets/images/CountryCode/Georgia.svg",
        "CountryCode":"995"
    },    {
        "CountryName":"Germany",
        "FlagIcon":"/Assets/images/CountryCode/Germany.svg",
        "CountryCode":"49"
    },
    {
        "CountryName":"Ghana",
        "FlagIcon":"/Assets/images/CountryCode/Ghana.svg",
        "CountryCode":"233"
    },
    {
        "CountryName":"Gibraltar",
        "FlagIcon":"/Assets/images/CountryCode/Gibraltar.svg",
        "CountryCode":"350"
    },
    {
        "CountryName":"Greece",
        "FlagIcon":"/Assets/images/CountryCode/Greece.svg",
        "CountryCode":"30"
    },
    {
        "CountryName":"Greenland",
        "FlagIcon":"/Assets/images/CountryCode/Greenland.svg",
        "CountryCode":"299"
    },
    {
        "CountryName":"Grenada",
        "FlagIcon":"/Assets/images/CountryCode/Grenada.svg",
        "CountryCode":"1-473"
    },
    {
        "CountryName":"Guadeloupe",
        "FlagIcon":"/Assets/images/CountryCode/Guadeloupe.svg",
        "CountryCode":"590"
    },
    {
        "CountryName":"Guam",
        "FlagIcon":"/Assets/images/CountryCode/Guam.svg",
        "CountryCode":"1-671"
    },
    {
        "CountryName":"Guatemala",
        "FlagIcon":"/Assets/images/CountryCode/Guatemala.svg",
        "CountryCode":"502"
    },
    {
        "CountryName":"Guernsey",
        "FlagIcon":"/Assets/images/CountryCode/Guernsey.svg",
        "CountryCode":"44-1481"
    },
    {
        "CountryName":"Guinea",
        "FlagIcon":"/Assets/images/CountryCode/Guinea.svg",
        "CountryCode":"224"
    },
    {
        "CountryName":"Guinea-Bissau",
        "FlagIcon":"/Assets/images/CountryCode/Guinea-Bissau.svg",
        "CountryCode":"245"
    },
    {
        "CountryName":"Guyana",
        "FlagIcon":"/Assets/images/CountryCode/Guyana.svg",
        "CountryCode":"592"
    },
    {
        "CountryName":"Haiti",
        "FlagIcon":"/Assets/images/CountryCode/Haiti.svg",
        "CountryCode":"509"
    },
    {
        "CountryName":"Honduras",
        "FlagIcon":"/Assets/images/CountryCode/Honduras.svg",
        "CountryCode":"504"
    },
    {
        "CountryName":"Hong Kong",
        "FlagIcon":"/Assets/images/CountryCode/HongKong.svg",
        "CountryCode":"852"
    },
    {
        "CountryName":"Hungary",
        "FlagIcon":"/Assets/images/CountryCode/Hungary.svg",
        "CountryCode":"36"
    },
    {
        "CountryName":"Iceland",
        "FlagIcon":"/Assets/images/CountryCode/Iceland.svg",
        "CountryCode":"354"
    },
    {
        "CountryName":"India",
        "FlagIcon":"/Assets/images/CountryCode/India.svg",
        "CountryCode":"91"
    },
    {
        "CountryName":"Indonesia",
        "FlagIcon":"/Assets/images/CountryCode/Indonesia.svg",
        "CountryCode":"62"
    },
    {
        "CountryName":"Iran",
        "FlagIcon":"/Assets/images/CountryCode/Iran.svg",
        "CountryCode":"98"
    },
    {
        "CountryName":"Iraq",
        "FlagIcon":"/Assets/images/CountryCode/Iraq.svg",
        "CountryCode":"964"
    },
    {
        "CountryName":"Ireland",
        "FlagIcon":"/Assets/images/CountryCode/Ireland.svg",
        "CountryCode":"353"
    },
    {
        "CountryName":"Isle of Man",
        "FlagIcon":"/Assets/images/CountryCode/IsleofMan.svg",
        "CountryCode":"44-1624"
    },
    {
        "CountryName":"Israel",
        "FlagIcon":"/Assets/images/CountryCode/Israel.svg",
        "CountryCode":"972"
    },
    {
        "CountryName":"Italy",
        "FlagIcon":"/Assets/images/CountryCode/Italy.svg",
        "CountryCode":"39"
    },
    {
        "CountryName":"Jamaica",
        "FlagIcon":"/Assets/images/CountryCode/Jamaica.svg",
        "CountryCode":"1-876"
    },
    {
        "CountryName":"Jan Mayen",
        "FlagIcon":"/Assets/images/CountryCode/JanMayen.svg",
        "CountryCode":"47-79"
    },
    {
        "CountryName":"Japan",
        "FlagIcon":"/Assets/images/CountryCode/Japan.svg",
        "CountryCode":"81"
    },
    {
        "CountryName":"Jersey",
        "FlagIcon":"/Assets/images/CountryCode/Jersey.svg",
        "CountryCode":"44-1534"
    },
    {
        "CountryName":"Jordan",
        "FlagIcon":"/Assets/images/CountryCode/Jordan.svg",
        "CountryCode":"962"
    },
    {
        "CountryName":"Kazakhstan",
        "FlagIcon":"/Assets/images/CountryCode/Kazakhstan.svg",
        "CountryCode":"7"
    },
    {
        "CountryName":"Kenya",
        "FlagIcon":"/Assets/images/CountryCode/Kenya.svg",
        "CountryCode":"254"
    },
    {
        "CountryName":"Kiribati",
        "FlagIcon":"/Assets/images/CountryCode/Kiribati.svg",
        "CountryCode":"686"
    },
    {
        "CountryName":"North Korea",
        "FlagIcon":"/Assets/images/CountryCode/NorthKorea.svg",
        "CountryCode":"850"
    },
    {
        "CountryName":"South Korea",
        "FlagIcon":"/Assets/images/CountryCode/SouthKorea.svg",
        "CountryCode":"82"
    },
    {
        "CountryName":"Kosovo",
        "FlagIcon":"/Assets/images/CountryCode/Kosovo.svg",
        "CountryCode":"383"
    },
    {
        "CountryName":"Kuwait",
        "FlagIcon":"/Assets/images/CountryCode/Kuwait.svg",
        "CountryCode":"965"
    },
    {
        "CountryName":"Kyrgyzstan",
        "FlagIcon":"/Assets/images/CountryCode/Kyrgyzstan.svg",
        "CountryCode":"996"
    },
    {
        "CountryName":"Laos",
        "FlagIcon":"/Assets/images/CountryCode/Laos.svg",
        "CountryCode":"856"
    },
    {
        "CountryName":"Latvia",
        "FlagIcon":"/Assets/images/CountryCode/Latvia.svg",
        "CountryCode":"371"
    },
    {
        "CountryName":"Lebanon",
        "FlagIcon":"/Assets/images/CountryCode/Lebanon.svg",
        "CountryCode":"961"
    },
    {
        "CountryName":"Lesotho",
        "FlagIcon":"/Assets/images/CountryCode/Lesotho.svg",
        "CountryCode":"266"
    },
    {
        "CountryName":"Liberia",
        "FlagIcon":"/Assets/images/CountryCode/Liberia.svg",
        "CountryCode":"231"
    },
    {
        "CountryName":"Libya",
        "FlagIcon":"/Assets/images/CountryCode/Libya.svg",
        "CountryCode":"218"
    },
    {
        "CountryName":"Liechtenstein",
        "FlagIcon":"/Assets/images/CountryCode/Liechtenstein.svg",
        "CountryCode":"423"
    },
    {
        "CountryName":"Lithuania",
        "FlagIcon":"/Assets/images/CountryCode/Lithuania.svg",
        "CountryCode":"370"
    },
    {
        "CountryName":"Luxembourg",
        "FlagIcon":"/Assets/images/CountryCode/Luxembourg.svg",
        "CountryCode":"352"
    },
    {
        "CountryName":"Macau",
        "FlagIcon":"/Assets/images/CountryCode/Macau.svg",
        "CountryCode":"853"
    },
    {
        "CountryName":"Madagascar",
        "FlagIcon":"/Assets/images/CountryCode/Madagascar.svg",
        "CountryCode":"261"
    },
    {
        "CountryName":"Malawi",
        "FlagIcon":"/Assets/images/CountryCode/Malawi.svg",
        "CountryCode":"265"
    },
    {
        "CountryName":"Malaysia",
        "FlagIcon":"/Assets/images/CountryCode/Malaysia.svg",
        "CountryCode":"60"
    },
    {
        "CountryName":"Maldives",
        "FlagIcon":"/Assets/images/CountryCode/Maldives.svg",
        "CountryCode":"960"
    },
    {
        "CountryName":"Mali",
        "FlagIcon":"/Assets/images/CountryCode/Mali.svg",
        "CountryCode":"223"
    },
    {
        "CountryName":"Malta",
        "FlagIcon":"/Assets/images/CountryCode/Malta.svg",
        "CountryCode":"356"
    },
    {
        "CountryName":"Marshall Islands",
        "FlagIcon":"/Assets/images/CountryCode/MarshallIslands.svg",
        "CountryCode":"692"
    },
    {
        "CountryName":"Martinique",
        "FlagIcon":"/Assets/images/CountryCode/Martinique.svg",
        "CountryCode":"596"
    },
    {
        "CountryName":"Mauritania",
        "FlagIcon":"/Assets/images/CountryCode/Mauritania.svg",
        "CountryCode":"222"
    },
    {
        "CountryName":"Mauritius",
        "FlagIcon":"/Assets/images/CountryCode/Mauritius.svg",
        "CountryCode":"230"
    },
    {
        "CountryName":"Mayotte",
        "FlagIcon":"/Assets/images/CountryCode/Mayotte.svg",
        "CountryCode":"262"
    },
    {
        "CountryName":"Mexico",
        "FlagIcon":"/Assets/images/CountryCode/Mexico.svg",
        "CountryCode":"52"
    },
    {
        "CountryName":"Federated States of Micronesia",
        "FlagIcon":"/Assets/images/CountryCode/Micronesia.svg",
        "CountryCode":"691"
    },
    {
        "CountryName":"Moldova",
        "FlagIcon":"/Assets/images/CountryCode/Moldova.svg",
        "CountryCode":"373"
    },
    {
        "CountryName":"Monaco",
        "FlagIcon":"/Assets/images/CountryCode/Monaco.svg",
        "CountryCode":"377"
    },
    {
        "CountryName":"Mongolia",
        "FlagIcon":"/Assets/images/CountryCode/Mongolia.svg",
        "CountryCode":"976"
    },
    {
        "CountryName":"Montenegro",
        "FlagIcon":"/Assets/images/CountryCode/Montenegro.svg",
        "CountryCode":"382"
    },
    {
        "CountryName":"Montserrat",
        "FlagIcon":"/Assets/images/CountryCode/Montserrat.svg",
        "CountryCode":"1-664"
    },
    {
        "CountryName":"Morocco",
        "FlagIcon":"/Assets/images/CountryCode/Morocco.svg",
        "CountryCode":"212"
    },
    {
        "CountryName":"Mozambique",
        "FlagIcon":"/Assets/images/CountryCode/Mozambique.svg",
        "CountryCode":"258"
    },
    {
        "CountryName":"Myanmar",
        "FlagIcon":"/Assets/images/CountryCode/Myanmar.svg",
        "CountryCode":"95"
    },
    {
        "CountryName":"Namibia",
        "FlagIcon":"/Assets/images/CountryCode/Namibia.svg",
        "CountryCode":"264"
    },
    {
        "CountryName":"Nauru",
        "FlagIcon":"/Assets/images/CountryCode/Nauru.svg",
        "CountryCode":"674"
    },
    {
        "CountryName":"Nepal",
        "FlagIcon":"/Assets/images/CountryCode/Nepal.svg",
        "CountryCode":"977"
    },
    {
        "CountryName":"Netherlands",
        "FlagIcon":"/Assets/images/CountryCode/Netherlands.svg",
        "CountryCode":"31"
    },
    {
        "CountryName":"New Caledonia",
        "FlagIcon":"/Assets/images/CountryCode/NewCaledonia.svg",
        "CountryCode":"687"
    },
    {
        "CountryName":"New Zealand",
        "FlagIcon":"/Assets/images/CountryCode/NewZealand.svg",
        "CountryCode":"64"
    },
    {
        "CountryName":"Nicaragua",
        "FlagIcon":"/Assets/images/CountryCode/Nicaragua.svg",
        "CountryCode":"505"
    },
    {
        "CountryName":"Niger",
        "FlagIcon":"/Assets/images/CountryCode/Niger.svg",
        "CountryCode":"227"
    },

    {
        "CountryName":"Nigeria",
        "FlagIcon":"/Assets/images/CountryCode/Nigeria.svg",
        "CountryCode":"234"
    },
    {
        "CountryName":"Niue",
        "FlagIcon":"/Assets/images/CountryCode/Niue.svg",
        "CountryCode":"683"
    },
    {
        "CountryName":"Norfolk Island",
        "FlagIcon":"/Assets/images/CountryCode/NorfolkIsland.svg",
        "CountryCode":"672-3"
    },
    {
        "CountryName":"North Macedonia",
        "FlagIcon":"/Assets/images/CountryCode/NorthMacedonia.svg",
        "CountryCode":"389"
    },
    {
        "CountryName":"Northern Ireland",
        "FlagIcon":"/Assets/images/CountryCode/NorthernIreland.svg",
        "CountryCode":"44-28"
    },
    {
        "CountryName":"Northern Mariana Islands",
        "FlagIcon":"/Assets/images/CountryCode/NorthernMarianaIslands.svg",
        "CountryCode":"1-670"
    },
    {
        "CountryName":"Norway",
        "FlagIcon":"/Assets/images/CountryCode/Norway.svg",
        "CountryCode":"47"
    },
    {
        "CountryName":"Oman",
        "FlagIcon":"/Assets/images/CountryCode/Oman.svg",
        "CountryCode":"968"
    },
    {
        "CountryName":"Pakistan",
        "FlagIcon":"/Assets/images/CountryCode/Pakistan.svg",
        "CountryCode":"92"
    },
    {
        "CountryName":"Palau",
        "FlagIcon":"/Assets/images/CountryCode/Palau.svg",
        "CountryCode":"680"
    },
    {
        "CountryName":"State of Palestine",
        "FlagIcon":"/Assets/images/CountryCode/Palestine.svg",
        "CountryCode":"970"
    },
    {
        "CountryName":"Panama",
        "FlagIcon":"/Assets/images/CountryCode/Panama.svg",
        "CountryCode":"507"
    },
    {
        "CountryName":"Papua New Guinea",
        "FlagIcon":"/Assets/images/CountryCode/PapuaNewGuinea.svg",
        "CountryCode":"675"
    },
    {
        "CountryName":"Paraguay",
        "FlagIcon":"/Assets/images/CountryCode/Paraguay.svg",
        "CountryCode":"595"
    },
    {
        "CountryName":"Peru",
        "FlagIcon":"/Assets/images/CountryCode/Peru.svg",
        "CountryCode":"51"
    },
    {
        "CountryName":"Philippines",
        "FlagIcon":"/Assets/images/CountryCode/Philippines.svg",
        "CountryCode":"63"
    },
    {
        "CountryName":"Pitcairn Islands",
        "FlagIcon":"/Assets/images/CountryCode/Pitcairn.svg",
        "CountryCode":"64"
    },
    {
        "CountryName":"Poland",
        "FlagIcon":"/Assets/images/CountryCode/Poland.svg",
        "CountryCode":"48"
    },
    {
        "CountryName":"Portugal",
        "FlagIcon":"/Assets/images/CountryCode/Portugal.svg",
        "CountryCode":"351"
    },
    {
        "CountryName":"Puerto Rico",
        "FlagIcon":"/Assets/images/CountryCode/PuertoRico.svg",
        "CountryCode":"1-787"
    },
    {
        "CountryName":"Puerto Rico",
        "FlagIcon":"/Assets/images/CountryCode/PuertoRico.svg",
        "CountryCode":"1-939"
    },
    {
        "CountryName":"Qatar",
        "FlagIcon":"/Assets/images/CountryCode/Qatar.svg",
        "CountryCode":"974"
    },
    {
        "CountryName":"Réunion",
        "FlagIcon":"/Assets/images/CountryCode/Réunion.svg",
        "CountryCode":"262"
    },
    {
        "CountryName":"Romania",
        "FlagIcon":"/Assets/images/CountryCode/Romania.svg",
        "CountryCode":"40"
    },
    {
        "CountryName":"Russia",
        "FlagIcon":"/Assets/images/CountryCode/Russia.svg",
        "CountryCode":"7"
    },
    {
        "CountryName":"Rwanda",
        "FlagIcon":"/Assets/images/CountryCode/Rwanda.svg",
        "CountryCode":"250"
    },
    {
        "CountryName":"Saint Barthélemy",
        "FlagIcon":"/Assets/images/CountryCode/SaintBarthélemy.svg",
        "CountryCode":"590"
    },
    {
        "CountryName":"Saint Kitts and Nevis",
        "FlagIcon":"/Assets/images/CountryCode/Nevis.svg",
        "CountryCode":"1-869"
    },
    {
        "CountryName":"Saint Lucia",
        "FlagIcon":"/Assets/images/CountryCode/SaintLucia.svg",
        "CountryCode":"1-758"
    },
    {
        "CountryName":"Saint Martin",
        "FlagIcon":"/Assets/images/CountryCode/SaintMartin.svg",
        "CountryCode":"590"
    },
    {
        "CountryName":"Saint Pierre and Miquelon",
        "FlagIcon":"/Assets/images/CountryCode/SaintPierreAndMiquelon.svg",
        "CountryCode":"508"
    },
    {
        "CountryName":"Saint Vincent and the Grenadines",
        "FlagIcon":"/Assets/images/CountryCode/SaintVincentAndTheGrenadines.svg",
        "CountryCode":"1-784"
    },
    {
        "CountryName":"Samoa",
        "FlagIcon":"/Assets/images/CountryCode/Samoa.svg",
        "CountryCode":"685"
    },
    {
        "CountryName":"San Marino",
        "FlagIcon":"/Assets/images/CountryCode/SanMarino.svg",
        "CountryCode":"378"
    },
    {
        "CountryName":"São Tomé and Príncipe",
        "FlagIcon":"/Assets/images/CountryCode/SaoTomeAndPrincipe.svg",
        "CountryCode":"239"
    },
    {
        "CountryName":"Saudi Arabia",
        "FlagIcon":"/Assets/images/CountryCode/SaudiArabia.svg",
        "CountryCode":"966"
    },
    {
        "CountryName":"Senegal",
        "FlagIcon":"/Assets/images/CountryCode/Senegal.svg",
        "CountryCode":"221"
    },
    {
        "CountryName":"Serbia",
        "FlagIcon":"/Assets/images/CountryCode/Serbia.svg",
        "CountryCode":"381"
    },
    {
        "CountryName":"Seychelles",
        "FlagIcon":"/Assets/images/CountryCode/Seychelles.svg",
        "CountryCode":"248"
    },
    {
        "CountryName":"Sierra Leone",
        "FlagIcon":"/Assets/images/CountryCode/SierraLeone.svg",
        "CountryCode":"232"
    },
    {
        "CountryName":"Singapore",
        "FlagIcon":"/Assets/images/CountryCode/Singapore.svg",
        "CountryCode":"65"
    },
    {
        "CountryName":"Sint Maarten",
        "FlagIcon":"/Assets/images/CountryCode/SintMaarten.svg",
        "CountryCode":"1-721"
    },
    {
        "CountryName":"Slovakia",
        "FlagIcon":"/Assets/images/CountryCode/Slovakia.svg",
        "CountryCode":"421"
    },
    {
        "CountryName":"Slovenia",
        "FlagIcon":"/Assets/images/CountryCode/Slovenia.svg",
        "CountryCode":"386"
    },
    {
        "CountryName":"Solomon Islands",
        "FlagIcon":"/Assets/images/CountryCode/SolomonIslands.svg",
        "CountryCode":"677"
    },
    {
        "CountryName":"Somalia",
        "FlagIcon":"/Assets/images/CountryCode/Somalia.svg",
        "CountryCode":"252"
    },
    {
        "CountryName":"South Africa",
        "FlagIcon":"/Assets/images/CountryCode/SouthAfrica.svg",
        "CountryCode":"27"
    },
    {
        "CountryName":"South Georgia and the South Sandwich Islands",
        "FlagIcon":"/Assets/images/CountryCode/SouthGeorgiaAndTheSouthSandwichIslands.svg",
        "CountryCode":"500"
    },
    {
        "CountryName":"South Sudan",
        "FlagIcon":"/Assets/images/CountryCode/SouthSudan.svg",
        "CountryCode":"211"
    },
    {
        "CountryName":"Spain",
        "FlagIcon":"/Assets/images/CountryCode/Spain.svg",
        "CountryCode":"34"
    },
    {
        "CountryName":"Sri Lanka",
        "FlagIcon":"/Assets/images/CountryCode/SriLanka.svg",
        "CountryCode":"94"
    },
    {
        "CountryName":"Sudan",
        "FlagIcon":"/Assets/images/CountryCode/Sudan.svg",
        "CountryCode":"249"
    },
    {
        "CountryName":"Suriname",
        "FlagIcon":"/Assets/images/CountryCode/Suriname.svg",
        "CountryCode":"597"
    },
    {
        "CountryName":"Svalbard",
        "FlagIcon":"/Assets/images/CountryCode/JanMayen.svg",
        "CountryCode":"47-79"
    },
    {
        "CountryName":"Sweden",
        "FlagIcon":"/Assets/images/CountryCode/Sweden.svg",
        "CountryCode":"46"
    },
    {
        "CountryName":"Switzerland",
        "FlagIcon":"/Assets/images/CountryCode/Switzerland.svg",
        "CountryCode":"41"
    },
    {
        "CountryName":"Syria",
        "FlagIcon":"/Assets/images/CountryCode/Syria.svg",
        "CountryCode":"963"
    },
    {
        "CountryName":"Taiwan",
        "FlagIcon":"/Assets/images/CountryCode/Taiwan.svg",
        "CountryCode":"886"
    },
    {
        "CountryName":"Tajikistan",
        "FlagIcon":"/Assets/images/CountryCode/Tajikistan.svg",
        "CountryCode":"992"
    },
    {
        "CountryName":"Tanzania",
        "FlagIcon":"/Assets/images/CountryCode/Tanzania.svg",
        "CountryCode":"255"
    },
    {
        "CountryName":"Thailand",
        "FlagIcon":"/Assets/images/CountryCode/Thailand.svg",
        "CountryCode":"66"
    },
    {
        "CountryName":"Timor-Leste",
        "FlagIcon":"/Assets/images/CountryCode/Timor-Leste.svg",
        "CountryCode":"670"
    },    {
        "CountryName":"Togo",
        "FlagIcon":"/Assets/images/CountryCode/Togo.svg",
        "CountryCode":"228"
    },
    {
        "CountryName":"Tokelau",
        "FlagIcon":"/Assets/images/CountryCode/Tokelau.svg",
        "CountryCode":"690"
    },
    {
        "CountryName":"Tonga",
        "FlagIcon":"/Assets/images/CountryCode/Tonga.svg",
        "CountryCode":"676"
    },
    {
        "CountryName":"Trinidad and Tobago",
        "FlagIcon":"/Assets/images/CountryCode/TrinidadAndTobago.svg",
        "CountryCode":"1-868"
    },
    {
        "CountryName":"Tristan da Cunha",
        "FlagIcon":"/Assets/images/CountryCode/TristanDaCunha.svg",
        "CountryCode":"290-8"
    },
    {
        "CountryName":"Tunisia",
        "FlagIcon":"/Assets/images/CountryCode/Tunisia.svg",
        "CountryCode":"216"
    },
    {
        "CountryName":"Turkey",
        "FlagIcon":"/Assets/images/CountryCode/Türkiye.svg",
        "CountryCode":"90"
    },
    {
        "CountryName":"Turkmenistan",
        "FlagIcon":"/Assets/images/CountryCode/Turkmenistan.svg",
        "CountryCode":"993"
    },
    {
        "CountryName":"Turks and Caicos Islands",
        "FlagIcon":"/Assets/images/CountryCode/TurksAndCaicosIslands.svg",
        "CountryCode":"1-649"
    },
    {
        "CountryName":"Tuvalu",
        "FlagIcon":"/Assets/images/CountryCode/Tuvalu.svg",
        "CountryCode":"688"
    },
    {
        "CountryName":"Uganda",
        "FlagIcon":"/Assets/images/CountryCode/Uganda.svg",
        "CountryCode":"256"
    },
    {
        "CountryName":"Ukraine",
        "FlagIcon":"/Assets/images/CountryCode/Ukraine.svg",
        "CountryCode":"380"
    },
    {
        "CountryName":"United Arab Emirates",
        "FlagIcon":"/Assets/images/CountryCode/UnitedArabEmirates.svg",
        "CountryCode":"971"
    },
    {
        "CountryName":"United Kingdom",
        "FlagIcon":"/Assets/images/CountryCode/UnitedKingdom.svg",
        "CountryCode":"44"
    },
    {
        "CountryName":"United States",
        "FlagIcon":"/Assets/images/CountryCode/UnitedStates.svg",
        "CountryCode":"1"
    },
    {
        "CountryName":"Uruguay",
        "FlagIcon":"/Assets/images/CountryCode/Uruguay.svg",
        "CountryCode":"598"
    },
    {
        "CountryName":"US Virgin Islands",
        "FlagIcon":"/Assets/images/CountryCode/VirginIslands(U.S.).svg",
        "CountryCode":"1-340"
    },
    {
        "CountryName":"Uzbekistan",
        "FlagIcon":"/Assets/images/CountryCode/Uzbekistan.svg",
        "CountryCode":"998"
    },
    {
        "CountryName":"Vanuatu",
        "FlagIcon":"/Assets/images/CountryCode/Vanuatu.svg",
        "CountryCode":"678"
    },
    {
        "CountryName":"Venezuela",
        "FlagIcon":"/Assets/images/CountryCode/Venezuela.svg",
        "CountryCode":"58"
    },
    {
        "CountryName":"Vietnam",
        "FlagIcon":"/Assets/images/CountryCode/Vietnam.svg",
        "CountryCode":"84"
    },
    {
        "CountryName":"Wallis and Futuna",
        "FlagIcon":"/Assets/images/CountryCode/WallisAndFutuna.svg",
        "CountryCode":"681"
    },
    {
        "CountryName":"Yemen",
        "FlagIcon":"/Assets/images/CountryCode/Yemen.svg",
        "CountryCode":"967"
    },
    {
        "CountryName":"Zambia",
        "FlagIcon":"/Assets/images/CountryCode/Zambia.svg",
        "CountryCode":"260"
    },
    {
        "CountryName":"Zimbabwe",
        "FlagIcon":"/Assets/images/CountryCode/Zimbabwe.svg",
        "CountryCode":"263"
    }
]


window.OpenCountryCode = function(thiscontainer, textdisplayer, whichclass, functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    let ThisValueCountryCode = thiscontainer.getAttribute("country-code");

    if(document.getElementById("CountryCodeDropDown" + whichclass) != null)
    {
        window.PanelChoiceOpen.remove();
        window.PanelChoiceOpen = null;
    }
    else
    {
        if(window.PanelChoiceOpen != null)
        {
            window.PanelChoiceOpen.remove();
            window.PanelChoiceOpen = null;
        }

        window.PanelChoiceOpen = document.createElement("div");
        window.PanelChoiceOpen.className = "ContainerFlex";
        window.PanelChoiceOpen.id ="RoomTypeDropDown"+ whichclass;
        window.PanelChoiceOpen.style.bottom = 0;
        thiscontainer.append(window.PanelChoiceOpen);

        let DropDownContainer = document.createElement("div");
        DropDownContainer.className = "DropDownContainer HideScrollBar";
        window.PanelChoiceOpen.append(DropDownContainer);


        let ScrollToDropDown;

        for(let i = 0; i < window.CountryListCode.length; i++)
        {
            let DropDownSelectionContainer = document.createElement("button");
            DropDownSelectionContainer.className = "DropDownSelectionContainer DropDownWithStatus";
            DropDownSelectionContainer.onclick = function()
            {
                window.event.preventDefault();
                window.event.stopPropagation();

                window.PanelChoiceOpen.remove();
                window.PanelChoiceOpen = null;

                thiscontainer.setAttribute("country-code", window.CountryListCode[i].CountryCode);
                textdisplayer.innerHTML = "+" + window.CountryListCode[i].CountryCode;

                functiontocall();
            }
            DropDownContainer.append(DropDownSelectionContainer);
        
            let DropDownSelectionText = document.createElement("p");
            DropDownSelectionText.className = "DropDownSelectionText";
            DropDownSelectionText.innerHTML = window.CountryListCode[i].CountryName + " (" + window.CountryListCode[i].CountryCode + ")";
            DropDownSelectionContainer.append(DropDownSelectionText);

            // Get Information For Basic Scroll Start
            if(ThisValueCountryCode == window.CountryListCode[i].CountryCode)
            {
                ScrollToDropDown = DropDownSelectionContainer;
                DropDownSelectionContainer.classList.add("DropDownSelectionContainerSelected");
            }
        }

        window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown)
    }
}

window.OpenCountryChoice = function(thiscontainer, countryicon, textdisplayer, togglearrow, whichclass, functiontocall)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    let CountrySelected = thiscontainer.getAttribute("country-selected");

    window.RotateToggle(togglearrow, true);

    if(document.getElementById("CountryChoiceDropDown" + whichclass) != null)
    {
        window.PanelChoiceOpen.remove();
        window.PanelChoiceOpen = null;
    }
    else
    {
        if(window.PanelChoiceOpen != null)
        {
            window.PanelChoiceOpen.remove();
            window.PanelChoiceOpen = null;
        }

        window.PanelChoiceOpen = document.createElement("div");
        window.PanelChoiceOpen.className = "ContainerFlex";
        window.PanelChoiceOpen.id = "CountryChoiceDropDown" + whichclass;
        window.PanelChoiceOpen.style.bottom = 0;
        thiscontainer.append(window.PanelChoiceOpen);

        let DropDownContainer = document.createElement("div");
        DropDownContainer.className = "DropDownContainer HideScrollBar";
        window.PanelChoiceOpen.append(DropDownContainer);


        let ScrollToDropDown;

        for(let i = 0; i < window.CountryListCode.length; i++)
        {
            let DropDownSelectionContainer = document.createElement("button");
            DropDownSelectionContainer.className = "DropDownSelectionContainer DropDownWithStatus";
            DropDownSelectionContainer.onclick = function()
            {
                window.event.preventDefault();
                window.event.stopPropagation();
                window.RotateToggle("", true);

                window.PanelChoiceOpen.remove();
                window.PanelChoiceOpen = null;

                thiscontainer.setAttribute("country-selected", window.CountryListCode[i].CountryName);
                textdisplayer.innerHTML = window.CountryListCode[i].CountryName;
                countryicon.src = window.CountryListCode[i].FlagIcon;
                
                functiontocall();
            }
            DropDownContainer.append(DropDownSelectionContainer);

            let CircleInsideInputField = document.createElement("img");
            CircleInsideInputField.className = "CircleInsideInputField";
            CircleInsideInputField.src = window.CountryListCode[i].FlagIcon;
            DropDownSelectionContainer.append(CircleInsideInputField);
        
            let DropDownSelectionText = document.createElement("p");
            DropDownSelectionText.className = "DropDownSelectionText";
            DropDownSelectionText.innerHTML = window.CountryListCode[i].CountryName;
            DropDownSelectionContainer.append(DropDownSelectionText);

            // Get Information For Basic Scroll Start
            if(CountrySelected == window.CountryListCode[i].CountryName)
            {
                ScrollToDropDown = DropDownSelectionContainer;
                DropDownSelectionContainer.classList.add("DropDownSelectionContainerSelected");
            }
        }

        window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown)
    }
}